module.exports = __webpack_public_path__ + "img/4-3.1db3adf5.png";